import { gql, useQuery } from '@apollo/client';
import { callSideEffects } from '../../util';
import { CurrencyFormats } from '../../contracts/types';
const ESTAB_OFFERS_QUERY = gql `
    query EstabOffersResult($request: estabOffersRequest!) {
        estabOffers(request: $request) {
            offers {
                airport
                airportCode
                price
                date
                boardType
                boardId
                priceFormatted {
                    formatted
                    parts {
                        value
                        type
                    }
                    value
                }
            }
        }
    }
`;
export function useEstabOffers(estabOffersRequest, sideEffects, skipQuery = false) {
    const { estabID, duration, adults, airportCodes } = estabOffersRequest;
    const skip = Boolean(!estabID || !duration || !adults || !airportCodes) || skipQuery;
    return useQuery(ESTAB_OFFERS_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
        variables: {
            request: estabOffersRequest,
            format: CurrencyFormats.Rounded,
        },
        skip,
        onCompleted: (completedData) => {
            if (sideEffects) {
                callSideEffects(sideEffects, completedData);
            }
        },
    });
}
